const imgToBase64 = (url) => {
  return new Promise((resolve) => {
    let canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.crossOrigin = 'Anonymous' // 解决Canvas.toDataURL 图片跨域问题
    img.onload = () => {
      const width = img.width
      const height = img.height
      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0, width, height)
      const dataURL = canvas.toDataURL('image/png')
      canvas = null
      resolve(dataURL)
    }
    img.src = url
  })
}

export default {
  imgToBase64
}
